import startCase from 'lodash/startCase'

export default path => path && startCase(path.replace(/^.*[\\/]/, '').slice(0, -3))
